import asyncActionTypes from '../actions/types.js';

const initialState = {
  banner: [],
};

const PersonalizedAcquisition = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND.START:
    case asyncActionTypes.RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND.FAIL:
      return {
        ...state,
        banner: [],
      };
    case asyncActionTypes.RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND.SUCCESS:
      return {
        ...state,
        banner: action.payload,
      };
    default:
      return state;
  }
};

export default PersonalizedAcquisition;